/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useFormContext } from '@jalik/react-form'
import { FormTextFieldProps } from '../../../../client/js/components/form/fields/FormField'
import { parseNumber } from '@jalik/form-parser'
import LeaseTemplateInput, { LeaseTemplateInputProps } from '../inputs/LeaseTemplateInput'

function LeaseTemplateField (props: FormTextFieldProps & Partial<LeaseTemplateInputProps>) {
  const { name = 'templateId', ...others } = props

  const { errors, getFieldProps, handleSetValue } = useFormContext()
  const fieldProps = getFieldProps(name, others)

  return (
    <LeaseTemplateInput
      error={errors[name]?.message}
      {...fieldProps}
      name={name}
      onChange={handleSetValue(name, { parse: parseNumber })}
    />
  )
}

export default LeaseTemplateField
